import { setCurrentProject, updateProjectLanguageAction } from './ProjectAction';
import { getLanguages, updateLanguages } from '../services/napi';
import {
  LANGUAGE_FETCH_SUCCESS,
  LANGUAGE_FETCH_FAIL,
  LANGUAGE_UPDATE_SUCCESS
} from '../constant/actionType';

const store = window.localStorage;

function fetchLanguageFail() {
  return {
    error: 'PROJECT_FETCH_FAIL',
    type: LANGUAGE_FETCH_FAIL
  };
}

export function fetchLanguages() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;

    const response = await getLanguages(projectId);

    dispatch({ data: response.data, type: LANGUAGE_FETCH_SUCCESS });
  };
}

export function getCurrentProjectLanguages(onSuccess) {
  return async (dispatch) => {
    try {
      const currentProject = JSON.parse(store.getItem('currentProject'));
      const response = await getLanguages(currentProject._id);

      dispatch({ data: response.data, type: LANGUAGE_FETCH_SUCCESS });

      onSuccess();
    } catch (error) {
      dispatch(fetchLanguageFail());
    }
  };
}

export function updateLanguage(isEnable, id) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await updateLanguages(projectId, { id, isEnable });

      const newLanguages = response.data.updatedLanguages;
      const currentProject = JSON.parse(store.getItem('currentProject'));
      currentProject.languages = newLanguages;

      dispatch({
        data: response.data.activeLanguages,
        type: LANGUAGE_UPDATE_SUCCESS
      });
      dispatch(setCurrentProject(currentProject));
      dispatch(updateProjectLanguageAction(currentProject, newLanguages));
    } catch (error) {
      console.error(error);
    }
  };
}
